<style scoped>
    @import url("../../../styles/smartControl/alertTable.scss");
</style>

<template>
    <div class="box_alertTable">

        <!-- LOADING após search btn -->
        <div v-if="flagLoading" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <div v-if="liElExec.length > 0 && !flagLoading" class="painelLiEl">

            <div v-for="(el,i) in liElExec" :key="i" class="elLi" :style="{'background':el.status_cor}">

                <span class="el"><v-icon>{{ el.icon }}</v-icon></span>
                <v-divider class="mx-2" color="#f39c12" vertical></v-divider>

                <span class="el" :style="{'min-width':'80px'}">{{ el.categoria }}</span>
                <v-divider class="mx-2" color="#f39c12" vertical></v-divider>

                <span class="el" :style="{'min-width':'100px'}">{{ el.data }}</span>
                <v-divider class="mx-2" color="#f39c12" vertical></v-divider>

                <span class="el" :style="{'font-size':'0.9rem'}">{{ el.nota }}</span>
                <v-divider class="mx-2" color="#f39c12" vertical></v-divider>

            </div>
        </div>

        <div v-if="liElExec.length==0 && !flagLoading">
            <span>{{ msgEntrada }}</span>
        </div>

    </div>
</template>

<script>
import axios from 'axios'

//import DialogExec from './DialogExec.vue'

export default {

    props:['execSys', 'emailCliente'],

    data() {
        return {

            //
            flagLoading:true,
            //flagLoading:false, // teste 0

            // -- sistema do cliente rcv via props.
            sysSelected:'',

            //
            liElExec:[], // -- dia mais recente da lista geral de execução.
            /*liElExec:[
                {
                    'data':'16/09/2025-19:01',
                    'icon':'mdi-sprout',
                    'categoria':'Produção',
                    'nota':'O sistema atingiu o alvo fase pintor',
                    'status_cor':''
                }
            ],*/
            msgEntrada:'Nenhum alerta no momento.',
        }
    },

    methods:{

        callInit() {

            this.flagLoading = true

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let self = this

            let params = {'cliente':this.emailCliente, 'sistema':this.sysSelected}

            let url = self.$store.state.pathAxiosBASE + '/getalerts' // 17/09/2025

            let statusReq = 0

            axios.post(url, params, {headers}).then(function (res) {

                statusReq = res.status
                if (statusReq === 403) {
                    //showToast("Sem permissão para esta ação."); // snackbar
                    console.log('403')
                    // fluxo alternativo sem lançar erro
                    return null;
                }

                let liInvertida = []
                liInvertida = res.data.result
                if (Array.isArray(liInvertida)) { self.liElExec = liInvertida.reverse(); }
                return
            })

            console.log(statusReq)
            if (statusReq != 200) {

                setTimeout(() => {
                    self.flagLoading = false // -- encerrar loading
                    self.msgEntrada = 'Tente novamente mais tarde.'
                },5000)
            }
        },
    },

    created() {
        window.scrollTo(0,0)

        this.sysSelected = this.execSys
        //console.log('[ExecTable] execSys -> sys_selected: ',this.sysSelected)
        //console.log('[ExecTable] emailCliente: ',this.emailCliente)

        this.callInit()
    }
}
</script>